import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ChangeSubscriptionPlan200,
  ChangeSubscriptionPlanBody,
  CheckSubscriptionStatus200,
  CheckSubscriptionStatusParams,
  CreateSubscriptionSession200,
  CreateSubscriptionSessionBody,
  GetPlanChangeOptions200,
  GetSubscriptionByOrder200,
  GetSubscriptionByOrder404,
  GetUserSubscriptions200,
  GetUserSubscriptions401,
  GetUserSubscriptionsParams,
  HandleWebhook200,
  HandleWebhookBody,
  InitSubscriptionSession200,
  InitiateSubscription200,
  InitiateSubscription400,
  InitiateSubscription401,
  InitiateSubscriptionBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 새로운 구독을 초기화합니다
 * @summary 구독 초기화
 */
export const initiateSubscription = (
    initiateSubscriptionBody: InitiateSubscriptionBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<InitiateSubscription200>(
      {url: `/api/v1/subscriptions/initiate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: initiateSubscriptionBody
    },
      options);
    }
  


export const getInitiateSubscriptionMutationOptions = <TError = InitiateSubscription400 | InitiateSubscription401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateSubscription>>, TError,{data: InitiateSubscriptionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof initiateSubscription>>, TError,{data: InitiateSubscriptionBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiateSubscription>>, {data: InitiateSubscriptionBody}> = (props) => {
          const {data} = props ?? {};

          return  initiateSubscription(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InitiateSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof initiateSubscription>>>
    export type InitiateSubscriptionMutationBody = InitiateSubscriptionBody
    export type InitiateSubscriptionMutationError = InitiateSubscription400 | InitiateSubscription401

    /**
 * @summary 구독 초기화
 */
export const useInitiateSubscription = <TError = InitiateSubscription400 | InitiateSubscription401,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateSubscription>>, TError,{data: InitiateSubscriptionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof initiateSubscription>>,
        TError,
        {data: InitiateSubscriptionBody},
        TContext
      > => {

      const mutationOptions = getInitiateSubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 현재 사용자의 구독 목록을 조회합니다. status 파라미터로 특정 상태의 구독만 필터링할 수 있습니다.
 * @summary 사용자 구독 목록 조회
 */
export const getUserSubscriptions = (
    params?: GetUserSubscriptionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetUserSubscriptions200>(
      {url: `/api/v1/subscriptions/my`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserSubscriptionsQueryKey = (params?: GetUserSubscriptionsParams,) => {
    return [`/api/v1/subscriptions/my`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserSubscriptionsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getUserSubscriptions>>, TError = GetUserSubscriptions401>(params?: GetUserSubscriptionsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUserSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSubscriptionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserSubscriptions>>> = ({ signal }) => getUserSubscriptions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUserSubscriptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserSubscriptionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getUserSubscriptions>>>
export type GetUserSubscriptionsInfiniteQueryError = GetUserSubscriptions401

/**
 * @summary 사용자 구독 목록 조회
 */
export const useGetUserSubscriptionsInfinite = <TData = Awaited<ReturnType<typeof getUserSubscriptions>>, TError = GetUserSubscriptions401>(
 params?: GetUserSubscriptionsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUserSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserSubscriptionsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetUserSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getUserSubscriptions>>, TError = GetUserSubscriptions401>(params?: GetUserSubscriptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserSubscriptionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserSubscriptions>>> = ({ signal }) => getUserSubscriptions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserSubscriptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserSubscriptions>>>
export type GetUserSubscriptionsQueryError = GetUserSubscriptions401

/**
 * @summary 사용자 구독 목록 조회
 */
export const useGetUserSubscriptions = <TData = Awaited<ReturnType<typeof getUserSubscriptions>>, TError = GetUserSubscriptions401>(
 params?: GetUserSubscriptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserSubscriptionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 특정 주문에 연결된 구독 정보를 조회합니다.
 * @summary 주문별 구독 정보 조회
 */
export const getSubscriptionByOrder = (
    orderId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetSubscriptionByOrder200>(
      {url: `/api/v1/subscriptions/by-order/${orderId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSubscriptionByOrderQueryKey = (orderId: string,) => {
    return [`/api/v1/subscriptions/by-order/${orderId}`] as const;
    }

    
export const getGetSubscriptionByOrderInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionByOrder>>, TError = GetSubscriptionByOrder404>(orderId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubscriptionByOrder>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionByOrderQueryKey(orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionByOrder>>> = ({ signal }) => getSubscriptionByOrder(orderId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubscriptionByOrder>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionByOrderInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionByOrder>>>
export type GetSubscriptionByOrderInfiniteQueryError = GetSubscriptionByOrder404

/**
 * @summary 주문별 구독 정보 조회
 */
export const useGetSubscriptionByOrderInfinite = <TData = Awaited<ReturnType<typeof getSubscriptionByOrder>>, TError = GetSubscriptionByOrder404>(
 orderId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubscriptionByOrder>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSubscriptionByOrderInfiniteQueryOptions(orderId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetSubscriptionByOrderQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionByOrder>>, TError = GetSubscriptionByOrder404>(orderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionByOrder>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionByOrderQueryKey(orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionByOrder>>> = ({ signal }) => getSubscriptionByOrder(orderId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionByOrder>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionByOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionByOrder>>>
export type GetSubscriptionByOrderQueryError = GetSubscriptionByOrder404

/**
 * @summary 주문별 구독 정보 조회
 */
export const useGetSubscriptionByOrder = <TData = Awaited<ReturnType<typeof getSubscriptionByOrder>>, TError = GetSubscriptionByOrder404>(
 orderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionByOrder>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSubscriptionByOrderQueryOptions(orderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 현재 구독의 플랜을 변경
 * @summary 구독 플랜 변경
 */
export const changeSubscriptionPlan = (
    subscriptionId: string,
    changeSubscriptionPlanBody: ChangeSubscriptionPlanBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ChangeSubscriptionPlan200>(
      {url: `/api/v1/subscriptions/${subscriptionId}/plan-change`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changeSubscriptionPlanBody
    },
      options);
    }
  


export const getChangeSubscriptionPlanMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeSubscriptionPlan>>, TError,{subscriptionId: string;data: ChangeSubscriptionPlanBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changeSubscriptionPlan>>, TError,{subscriptionId: string;data: ChangeSubscriptionPlanBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeSubscriptionPlan>>, {subscriptionId: string;data: ChangeSubscriptionPlanBody}> = (props) => {
          const {subscriptionId,data} = props ?? {};

          return  changeSubscriptionPlan(subscriptionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeSubscriptionPlanMutationResult = NonNullable<Awaited<ReturnType<typeof changeSubscriptionPlan>>>
    export type ChangeSubscriptionPlanMutationBody = ChangeSubscriptionPlanBody
    export type ChangeSubscriptionPlanMutationError = unknown

    /**
 * @summary 구독 플랜 변경
 */
export const useChangeSubscriptionPlan = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeSubscriptionPlan>>, TError,{subscriptionId: string;data: ChangeSubscriptionPlanBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof changeSubscriptionPlan>>,
        TError,
        {subscriptionId: string;data: ChangeSubscriptionPlanBody},
        TContext
      > => {

      const mutationOptions = getChangeSubscriptionPlanMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 현재 구독에서 변경 가능한 플랜 옵션들을 조회합니다
 * @summary 플랜 변경 옵션 조회
 */
export const getPlanChangeOptions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetPlanChangeOptions200>(
      {url: `/api/v1/subscriptions/plan-change/options`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPlanChangeOptionsQueryKey = () => {
    return [`/api/v1/subscriptions/plan-change/options`] as const;
    }

    
export const getGetPlanChangeOptionsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getPlanChangeOptions>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPlanChangeOptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanChangeOptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanChangeOptions>>> = ({ signal }) => getPlanChangeOptions(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPlanChangeOptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlanChangeOptionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPlanChangeOptions>>>
export type GetPlanChangeOptionsInfiniteQueryError = unknown

/**
 * @summary 플랜 변경 옵션 조회
 */
export const useGetPlanChangeOptionsInfinite = <TData = Awaited<ReturnType<typeof getPlanChangeOptions>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPlanChangeOptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPlanChangeOptionsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetPlanChangeOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getPlanChangeOptions>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlanChangeOptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanChangeOptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanChangeOptions>>> = ({ signal }) => getPlanChangeOptions(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlanChangeOptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlanChangeOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlanChangeOptions>>>
export type GetPlanChangeOptionsQueryError = unknown

/**
 * @summary 플랜 변경 옵션 조회
 */
export const useGetPlanChangeOptions = <TData = Awaited<ReturnType<typeof getPlanChangeOptions>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlanChangeOptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPlanChangeOptionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 새로운 구독 세션을 생성합니다
 * @summary 구독 세션 생성
 */
export const createSubscriptionSession = (
    createSubscriptionSessionBody: CreateSubscriptionSessionBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CreateSubscriptionSession200>(
      {url: `/api/v1/subscriptions/session/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSubscriptionSessionBody
    },
      options);
    }
  


export const getCreateSubscriptionSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionSession>>, TError,{data: CreateSubscriptionSessionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionSession>>, TError,{data: CreateSubscriptionSessionBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSubscriptionSession>>, {data: CreateSubscriptionSessionBody}> = (props) => {
          const {data} = props ?? {};

          return  createSubscriptionSession(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSubscriptionSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createSubscriptionSession>>>
    export type CreateSubscriptionSessionMutationBody = CreateSubscriptionSessionBody
    export type CreateSubscriptionSessionMutationError = unknown

    /**
 * @summary 구독 세션 생성
 */
export const useCreateSubscriptionSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionSession>>, TError,{data: CreateSubscriptionSessionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createSubscriptionSession>>,
        TError,
        {data: CreateSubscriptionSessionBody},
        TContext
      > => {

      const mutationOptions = getCreateSubscriptionSessionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 구독 세션을 초기화합니다
 * @summary 세션 초기화
 */
export const initSubscriptionSession = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<InitSubscriptionSession200>(
      {url: `/api/v1/subscriptions/session/init`, method: 'POST'
    },
      options);
    }
  


export const getInitSubscriptionSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initSubscriptionSession>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof initSubscriptionSession>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initSubscriptionSession>>, void> = () => {
          

          return  initSubscriptionSession(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InitSubscriptionSessionMutationResult = NonNullable<Awaited<ReturnType<typeof initSubscriptionSession>>>
    
    export type InitSubscriptionSessionMutationError = unknown

    /**
 * @summary 세션 초기화
 */
export const useInitSubscriptionSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initSubscriptionSession>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof initSubscriptionSession>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getInitSubscriptionSessionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 현재 사용자의 구독 상태를 확인합니다
 * @summary 구독 상태 확인
 */
export const checkSubscriptionStatus = (
    params?: CheckSubscriptionStatusParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CheckSubscriptionStatus200>(
      {url: `/api/v1/subscriptions/status`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCheckSubscriptionStatusQueryKey = (params?: CheckSubscriptionStatusParams,) => {
    return [`/api/v1/subscriptions/status`, ...(params ? [params]: [])] as const;
    }

    
export const getCheckSubscriptionStatusInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof checkSubscriptionStatus>>, TError = unknown>(params?: CheckSubscriptionStatusParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkSubscriptionStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckSubscriptionStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkSubscriptionStatus>>> = ({ signal }) => checkSubscriptionStatus(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkSubscriptionStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type CheckSubscriptionStatusInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof checkSubscriptionStatus>>>
export type CheckSubscriptionStatusInfiniteQueryError = unknown

/**
 * @summary 구독 상태 확인
 */
export const useCheckSubscriptionStatusInfinite = <TData = Awaited<ReturnType<typeof checkSubscriptionStatus>>, TError = unknown>(
 params?: CheckSubscriptionStatusParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof checkSubscriptionStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCheckSubscriptionStatusInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCheckSubscriptionStatusQueryOptions = <TData = Awaited<ReturnType<typeof checkSubscriptionStatus>>, TError = unknown>(params?: CheckSubscriptionStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkSubscriptionStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckSubscriptionStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkSubscriptionStatus>>> = ({ signal }) => checkSubscriptionStatus(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkSubscriptionStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type CheckSubscriptionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof checkSubscriptionStatus>>>
export type CheckSubscriptionStatusQueryError = unknown

/**
 * @summary 구독 상태 확인
 */
export const useCheckSubscriptionStatus = <TData = Awaited<ReturnType<typeof checkSubscriptionStatus>>, TError = unknown>(
 params?: CheckSubscriptionStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkSubscriptionStatus>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCheckSubscriptionStatusQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * NicePay에서 결제 상태 변경 등의 이벤트를 서버로 알리기 위해 호출
 * @summary NicePay 웹훅 처리
 */
export const handleWebhook = (
    handleWebhookBody: HandleWebhookBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<HandleWebhook200>(
      {url: `/api/v1/subscriptions/webhook`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handleWebhookBody
    },
      options);
    }
  


export const getHandleWebhookMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handleWebhook>>, TError,{data: HandleWebhookBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof handleWebhook>>, TError,{data: HandleWebhookBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handleWebhook>>, {data: HandleWebhookBody}> = (props) => {
          const {data} = props ?? {};

          return  handleWebhook(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HandleWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof handleWebhook>>>
    export type HandleWebhookMutationBody = HandleWebhookBody
    export type HandleWebhookMutationError = void

    /**
 * @summary NicePay 웹훅 처리
 */
export const useHandleWebhook = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handleWebhook>>, TError,{data: HandleWebhookBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof handleWebhook>>,
        TError,
        {data: HandleWebhookBody},
        TContext
      > => {

      const mutationOptions = getHandleWebhookMutationOptions(options);

      return useMutation(mutationOptions);
    }
    